import Promise from "bluebird";
import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getSensors, getSensorsByParams} from "apollo/queries/getSensors";
import {getNFCTags, getNFCTagsByParams, getNFCTagsConnection, countNFCTagsByLatLngQuery,
countSerialRangeQuery, getSerialRangeQuery} from "apollo/queries/getNFCTags";
import {getLightings, getLightingsByParams} from "apollo/queries/getLightings";
import {getIBeacons, getInventoryIBeacons,
getIBeaconsByParams} from "apollo/queries/getIBeacons";
import {getEddystones, getEddystonesByParams} from "apollo/queries/getEddystones";
import {getReaders, getReadersByParams} from "apollo/queries/getReaders";
import {getBluetoothHubs, getBluetoothHubsByParams} from "apollo/queries/getBluetoothHubs";
import {getGateways, getGatewaysByParams} from "apollo/queries/getGateways";
import {getIBeacon} from "apollo/queries/getIBeacon";
import {getEddystone} from "apollo/queries/getEddystone";
import {getReader} from "apollo/queries/getReader";
import {getBluetoothHub} from "apollo/queries/getBluetoothHub";
import {getGateway} from "apollo/queries/getGateway";
import {getDeviceLogs} from "apollo/queries/getDeviceLogs";
import {getModels} from "apollo/queries/getModels";
import {getWifiTests} from "apollo/queries/getWifiTests";
import {createDeviceMutation} from "apollo/mutations/createDevice";
import {updateDeviceMutation} from "apollo/mutations/updateDevice";
import {deleteDeviceMutation} from "apollo/mutations/deleteDevice";
import {createIBeaconMutation} from "apollo/mutations/createIBeacon";
import {updateIBeaconMutation} from "apollo/mutations/updateIBeacon";
import {deleteIBeaconMutation} from "apollo/mutations/deleteIBeacon";
import {createEddystoneMutation} from "apollo/mutations/createEddystone";
import {updateEddystoneMutation} from "apollo/mutations/updateEddystone";
import {deleteEddystoneMutation} from "apollo/mutations/deleteEddystone";
import {createReaderMutation} from "apollo/mutations/createReader";
import {updateReaderMutation} from "apollo/mutations/updateReader";
import {deleteReaderMutation} from "apollo/mutations/deleteReader";
import {createBluetoothHubMutation} from "apollo/mutations/createBluetoothHub";
import {updateBluetoothHubMutation} from "apollo/mutations/updateBluetoothHub";
import {deleteBluetoothHubMutation} from "apollo/mutations/deleteBluetoothHub";
import {createGatewayMutation} from "apollo/mutations/createGateway";
import {updateGatewayMutation} from "apollo/mutations/updateGateway";
import {deleteGatewayMutation} from "apollo/mutations/deleteGateway";
import {createDevicesMutation} from "apollo/mutations/createDevices";
import {deleteDevicesMutation} from "apollo/mutations/deleteDevices";
import {updateShadowMutation} from "apollo/mutations/updateShadow";
import {otaUpdateMutation} from "apollo/mutations/otaUpdate";
import {createMeshElementMutation} from "apollo/mutations/createMeshElement";
import {updateMeshElementMutation} from "apollo/mutations/updateMeshElement";
import {deleteMeshElementMutation} from "apollo/mutations/deleteMeshElement";
import {openBuzzVoxLockMutation} from "apollo/mutations/openBuzzVoxLock";
import {fetchError} from "../actions/Common";
import {fetchIBeaconsSuccess, fetchEddystonesSuccess, fetchReadersSuccess,
  fetchHubsSuccess, fetchGatewaysSuccess, fetchIBeaconSuccess,
  fetchEddystoneSuccess, fetchReaderSuccess, fetchHubSuccess,
  fetchGatewaySuccess, fetchSensorsSuccess, fetchNFCTagsSuccess,
  fetchNFCTagsConnectionSuccess,
  fetchLightingsSuccess, fetchModelsSuccess,
  createDeviceSuccess, updateDeviceSuccess, deleteDeviceSuccess,
  createIBeaconSuccess, updateIBeaconSuccess, deleteIBeaconSuccess,
  createEddystoneSuccess, updateEddystoneSuccess, deleteEddystoneSuccess,
  createReaderSuccess, updateReaderSuccess, deleteReaderSuccess,
  createBluetoothHubSuccess, updateBluetoothHubSuccess, deleteBluetoothHubSuccess,
  createGatewaySuccess, updateGatewaySuccess, deleteGatewaySuccess,
  createDevicesSuccess, deleteDevicesSuccess, validateDevicesSuccess,
  updateShadowSuccess, otaUpdateSuccess, fetchDeviceLogsSuccess,
  createMeshElementSuccess, updateMeshElementSuccess, deleteMeshElementSuccess,
  fetchWifiTestsSuccess, openBuzzVoxLockSuccess, countNFCTagsByLatLngSuccess,
  countSerialRangeSuccess, getSerialRangeSuccess} from "../actions/Device";
import {client} from "apollo/client";
import axios from 'axios';

import {
  FETCHSENSORS,
  FETCHNFCTAGS,
  FETCHNFCTAGSCONNECTION,
  COUNTNFCTAGSLATLNG,
  FETCHLIGHTINGS,
  FETCHIBEACONS,
  FETCHEDDYSTONES,
  FETCHREADERS,
  FETCHHUBS,
  FETCHGATEWAYS,
  FETCHIBEACON,
  FETCHEDDYSTONE,
  FETCHREADER,
  FETCHHUB,
  FETCHGATEWAY,
  FETCHMODELS,
  CREATEDEVICE,
  CREATEDEVICE_SUCCESS,
  UPDATEDEVICE,
  UPDATEDEVICE_SUCCESS,
  DELETEDEVICE,
  DELETEDEVICE_SUCCESS,
  CREATEIBEACON,
  CREATEIBEACON_SUCCESS,
  UPDATEIBEACON,
  UPDATEIBEACON_SUCCESS,
  DELETEIBEACON,
  DELETEIBEACON_SUCCESS,
  CREATEEDDYSTONE,
  CREATEEDDYSTONE_SUCCESS,
  UPDATEEDDYSTONE,
  UPDATEEDDYSTONE_SUCCESS,
  DELETEEDDYSTONE,
  DELETEEDDYSTONE_SUCCESS,
  CREATEREADER,
  CREATEREADER_SUCCESS,
  UPDATEREADER,
  UPDATEREADER_SUCCESS,
  DELETEREADER,
  DELETEREADER_SUCCESS,
  CREATEHUB,
  CREATEHUB_SUCCESS,
  UPDATEHUB,
  UPDATEHUB_SUCCESS,
  DELETEHUB,
  DELETEHUB_SUCCESS,
  CREATEGATEWAY,
  CREATEGATEWAY_SUCCESS,
  UPDATEGATEWAY,
  UPDATEGATEWAY_SUCCESS,
  DELETEGATEWAY,
  DELETEGATEWAY_SUCCESS,
  CREATEDEVICES,
  CREATEDEVICESPARALLEL,
  CREATEDEVICES_SUCCESS,
  DELETEDEVICES,
  DELETEDEVICES_SUCCESS,
  VALIDATEDEVICES,
  UPDATESHADOW,
  OTAUPDATE,
  FETCHDEVICELOGS,
  CREATEMESHELEMENT,
  UPDATEMESHELEMENT,
  DELETEMESHELEMENT,
  FETCHWIFITESTS,
  OPENBUZZVOXLOCK,
  COUNTNFCTAGSLATLNG_SUCCESS,
  COUNTSERIALRANGE,
  GETSERIALRANGE
} from "constants/ActionTypes";

const fetchSensorsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getSensors,
    variables: {
      application: applicationId
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const fetchNFCTagsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getNFCTags,
    variables: {
      application: applicationId
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const fetchNFCTagsConnectionRequest = async (applicationId, first, last, before, after,
models, searchParam, searchTerm) => {
  let { data, error } = await client.query({
    query: getNFCTagsConnection,
    variables: {
      whereArgs: {
        application: applicationId
      },
      first,
      last,
      before,
      after,
      models,
      searchParam,
      searchTerm
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const countNFCTagsByLatLngRequest = async (applicationId, models) => {
  let { data, error } = await client.query({
    query: countNFCTagsByLatLngQuery,
    variables: {
      application: applicationId,
      models
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const countSerialRangeRequest = async (application,
serialRangeStart, serialRangeEnd) => {
  let { data, error } = await client.query({
    query: countSerialRangeQuery,
    variables: {
      application,
      serialRangeStart,
      serialRangeEnd
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const getSerialRangeRequest = async (application) => {
  let { data, error } = await client.query({
    query: getSerialRangeQuery,
    variables: {
      application,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const fetchLightingsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getLightings,
    variables: {
      application: applicationId
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.rject(error);
  }
}

const fetchIBeaconsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getIBeacons,
    variables: {
      application: applicationId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchEddystonesRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getEddystones,
    variables: {
      application: applicationId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchReadersRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getReaders,
    variables: {
      application: applicationId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchHubsRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getBluetoothHubs,
      variables: {
        application: applicationId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchGatewaysRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getGateways,
      variables: {
        application: applicationId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}


const fetchIBeaconRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getIBeacon,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchEddystoneRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getEddystone,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchReaderRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getReader,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchHubRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getBluetoothHub,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchGatewayRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getGateway,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchModelsRequest = async () => {
  let { data, error } = await client.query({
    query: getModels,
    variables: {
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const createDeviceRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: createDeviceMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateDeviceRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateDeviceMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteDeviceRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteDeviceMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteDeviceById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createIBeaconRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: createIBeaconMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateIBeaconRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateIBeaconMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteIBeaconRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteIBeaconMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteIBeaconById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createEddystoneRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: createEddystoneMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateEddystoneRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateEddystoneMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteEddystoneRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteEddystoneMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteEddystoneById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createReaderRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: createReaderMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateReaderRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateReaderMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteReaderRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteReaderMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteReaderById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}


const createBluetoothHubRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: createBluetoothHubMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateBluetoothHubRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateBluetoothHubMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteBluetoothHubRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteBluetoothHubMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteBluetoothHubById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createGatewayRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createGatewayMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateGatewayRequest = async (input) => {

  console.log('inputGateway', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateGatewayMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteGatewayRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteGatewayMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteGatewayById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createDevicesRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createDevicesMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createNFCTagProgressiveLambdaRequest = async (startSerialNumber, quantity, batchIndex, batchQuantity,
model, application, args) => {
  try {
    const data = {
      startSerialNumber,
      quantity,
      batchIndex,
      batchQuantity,
      model,
      application,
      args
    };

    console.log('createNFCTagProgressiveLambdaRequest', data);

    await axios({
      method: 'POST',
      url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/extra/nfctags/create/progressive',
      headers: { 'content-type': 'application/json' },
      data: data
    })
      .then(response => response)
      .catch(error => error);
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteDevicesRequest = async (input) => {
  const {type, deviceIds} = input;

  try {
    let { data, error } = await client.mutate({
      mutation: deleteDevicesMutation,
      variables: {
        type, deviceIds
      }
    });

    console.log('data', data);

    if (data.deleteDevices.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Fail to delete devices");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const validateDevicesRequest = async (type, devices) => {
  try {
    let query;

    switch (type) {
      case 'iBeacon':
        query = getIBeaconsByParams;
        break;

      case 'eddystone':
        query = getEddystonesByParams;
        break;

      case 'reader':
        query = getReadersByParams;
        break;
      case 'bluetoothHub':
        query = getBluetoothHubsByParams;
        break;
      case 'gateway':
        query = getGatewaysByParams;
        break;
      case 'sensor':
        query = getSensorsByParams;
        break;
      case 'nfcTag':
        query = getNFCTagsByParams;
        break;
      case 'lighting':
        query = getLightingsByParams;
        break;
      default:
        query = getIBeaconsByParams;
        break;
    }

    return Promise.map(devices, async (device) => {
      let { data, error } = await client.query({
        query: query,
        variables: {
          ...device
        },
        fetchPolicy: 'network-only'
      });

      console.log('data', data);
      console.log('error', error);

      if (data) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(error);
      }
    });
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateShadowRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateShadowMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const otaUpdateRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: otaUpdateMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchDeviceLogsRequest = async (deviceId) => {
  let { data, error } = await client.query({
    query: getDeviceLogs,
    variables: {
      deviceId: deviceId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const createMeshElementRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createMeshElementMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateMeshElementRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateMeshElementMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteMeshElementRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteMeshElementMutation,
      variables: {
        meshElementId: input
      }
    });

    console.log('data', data);

    if (data.deleteMeshElementById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Mesh element not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchWifiTestsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getWifiTests,
    variables: {
      applicationId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const openBuzzVoxLockRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: openBuzzVoxLockMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

function* fetchSensorsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedSensors = yield call(fetchSensorsRequest, applicationId);
    yield put(fetchSensorsSuccess(applicationId, fetchedSensors));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchNFCTagsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedNFCTags = yield call(fetchNFCTagsRequest, applicationId);
    yield put(fetchNFCTagsSuccess(applicationId, fetchedNFCTags));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchNFCTagsConnectionCall({payload, first, last, before, after, models, searchParam, searchTerm}) {
  const {applicationId} = payload;

  try {
    const fetchedNFCTags = yield call(fetchNFCTagsConnectionRequest, applicationId, first, last, before, after,
    models, searchParam, searchTerm);
    yield put(fetchNFCTagsConnectionSuccess(applicationId, first, last, before,
      after, models, searchParam, searchTerm, fetchedNFCTags));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* countNFCTagsByLatLngCall({payload}) {
  const {applicationId, models} = payload;

  try {
    const response = yield call(countNFCTagsByLatLngRequest, applicationId, models);
    yield put(countNFCTagsByLatLngSuccess(applicationId, models, response));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* countSerialRangeCall({payload}) {
  const {applicationId, serialRangeStart, serialRangeEnd} = payload;

  try {
    const response = yield call(countSerialRangeRequest, applicationId,
    serialRangeStart, serialRangeEnd);
    yield put(countSerialRangeSuccess(applicationId, serialRangeStart, serialRangeEnd, response));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getSerialRangeCall({payload}) {
  const {applicationId} = payload;

  try {
    const response = yield call(getSerialRangeRequest, applicationId);
    yield put(getSerialRangeSuccess(applicationId, response));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchLightingsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedLightings = yield call(fetchLightingsRequest, applicationId);
    yield put(fetchLightingsSuccess(applicationId, fetchedLightings));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchIBeaconsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedIBeacons = yield call(fetchIBeaconsRequest, applicationId);
    yield put(fetchIBeaconsSuccess(applicationId, fetchedIBeacons));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchEddystonesCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchEddystones = yield call(fetchEddystonesRequest, applicationId);
    yield put(fetchEddystonesSuccess(applicationId, fetchEddystones));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchReadersCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchReaders = yield call(fetchReadersRequest, applicationId);
    yield put(fetchReadersSuccess(applicationId, fetchReaders));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchHubsCall({payload}) {
  console.log('fetchHubsCall', payload);
  const {applicationId} = payload;

  try {
    const fetchHubs = yield call(fetchHubsRequest, applicationId);
    yield put(fetchHubsSuccess(applicationId, fetchHubs));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchGatewaysCall({payload}) {
  console.log('fetchGatewaysCall', payload);
  const {applicationId} = payload;

  try {
    const fetchGateways = yield call(fetchGatewaysRequest, applicationId);
    yield put(fetchGatewaysSuccess(applicationId, fetchGateways));
  } catch (error) {
    yield put(fetchError(error));
  }
}


function* fetchIBeaconCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchedIBeacon = yield call(fetchIBeaconRequest, deviceId);
    yield put(fetchIBeaconSuccess(deviceId, fetchedIBeacon));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchEddystoneCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchEddystone = yield call(fetchEddystoneRequest, deviceId);
    yield put(fetchEddystoneSuccess(deviceId, fetchEddystone));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchReaderCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchReader = yield call(fetchReaderRequest, deviceId);
    yield put(fetchReaderSuccess(deviceId, fetchReader));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchHubCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchHub = yield call(fetchHubRequest, deviceId);
    yield put(fetchHubSuccess(deviceId, fetchHub));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchGatewayCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchGateway = yield call(fetchGatewayRequest, deviceId);
    yield put(fetchGatewaySuccess(deviceId, fetchGateway));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchModelsCall({payload}) {

  try {
    const fetchModels = yield call(fetchModelsRequest);
    yield put(fetchModelsSuccess(fetchModels));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createDeviceCall({payload}) {

  try {
    const createdDevice = yield call(createDeviceRequest, payload);
    yield put(createDeviceSuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateDeviceCall({payload}) {

  try {
    const updatedDevice = yield call(updateDeviceRequest, payload);
    yield put(updateDeviceSuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteDeviceCall({payload}) {

  try {
    const deletedDevice = yield call(deleteDeviceRequest, payload);
    yield put(deleteDeviceSuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createIBeaconCall({payload}) {

  try {
    const createdDevice = yield call(createIBeaconRequest, payload);
    yield put(createIBeaconSuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateIBeaconCall({payload}) {

  try {
    const updatedDevice = yield call(updateIBeaconRequest, payload);
    yield put(updateIBeaconSuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteIBeaconCall({payload}) {

  try {
    const deletedDevice = yield call(deleteIBeaconRequest, payload);
    yield put(deleteIBeaconSuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createEddystoneCall({payload}) {

  try {
    const createdDevice = yield call(createEddystoneRequest, payload);
    yield put(createEddystoneSuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateEddystoneCall({payload}) {

  try {
    const updatedDevice = yield call(updateEddystoneRequest, payload);
    yield put(updateEddystoneSuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteEddystoneCall({payload}) {

  try {
    const deletedDevice = yield call(deleteEddystoneRequest, payload);
    yield put(deleteEddystoneSuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}


function* createReaderCall({payload}) {

  try {
    const createdDevice = yield call(createReaderRequest, payload);
    yield put(createReaderSuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateReaderCall({payload}) {

  try {
    const updatedDevice = yield call(updateReaderRequest, payload);
    yield put(updateReaderSuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteReaderCall({payload}) {

  try {
    const deletedDevice = yield call(deleteReaderRequest, payload);
    yield put(deleteReaderSuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}


function* createBluetoothHubCall({payload}) {

  try {
    const createdDevice = yield call(createBluetoothHubRequest, payload);
    yield put(createBluetoothHubSuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateBluetoothHubCall({payload}) {

  try {
    const updatedDevice = yield call(updateBluetoothHubRequest, payload);
    yield put(updateBluetoothHubSuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteBluetoothHubCall({payload}) {

  try {
    const deletedDevice = yield call(deleteBluetoothHubRequest, payload);
    yield put(deleteBluetoothHubSuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}


function* createGatewayCall({payload}) {

  try {
    const createdDevice = yield call(createGatewayRequest, payload);
    yield put(createGatewaySuccess(createdDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateGatewayCall({payload}) {

  try {
    const updatedDevice = yield call(updateGatewayRequest, payload);
    yield put(updateGatewaySuccess(updatedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteGatewayCall({payload}) {

  try {
    const deletedDevice = yield call(deleteGatewayRequest, payload);
    yield put(deleteGatewaySuccess(deletedDevice));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createDevicesCall({payload, index}) {
  try {
    console.log('createDevicesCall index', index);
    const createdDevices = yield call(createDevicesRequest, payload);
    yield put(createDevicesSuccess(createdDevices, index));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createDevicesParallelCallSingle(startSerialNumber, quantity, noOfBatch, model, application,
args, index, returnIndex) {
  const batchQuantity = (index == noOfBatch - 1) ? (((quantity - 1) % (quantity / noOfBatch)) + 1)  : quantity / noOfBatch;
  try {
    const createdDevice = yield call(createNFCTagProgressiveLambdaRequest, startSerialNumber,
    quantity, index, batchQuantity, model, application, args);
    yield put(createDevicesSuccess(createdDevice, returnIndex))
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

// function* createDevicesParallelCall({payload, startIndex}) {
//   try {
//     console.log('createDevicesParallelCall startIndex', startIndex);
//     yield all(payload.map(
//       (device, i) => createDevicesParallelCallSingle(device, startIndex + i)
//     ));
//   } catch (error) {
//     console.log('error', error);
//     yield put(fetchError(error));
//   }
// }

function* createDevicesParallelCall({startSerialNumber, quantity, noOfSubBatch, model,
application, args, batchIndex}) {
  try {
    yield all([...Array(noOfSubBatch).keys()].map(
      (device, i) => createDevicesParallelCallSingle(startSerialNumber, quantity, noOfSubBatch, model,
      application,
      args, i, batchIndex * noOfSubBatch + i)
    ));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteDevicesCall({payload}) {

  try {
    const deletedDevices = yield call(deleteDevicesRequest, payload);
    yield put(deleteDevicesSuccess(deletedDevices));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* validateDevicesCall({payload}) {
  const {type, devices} = payload;

  try {
    const validateDevices = yield call(validateDevicesRequest, type, devices);

    console.log('validateDevices', validateDevices);

    let duplicated = validateDevices.map((deviceArr) => {
      return (deviceArr.getIBeacons || deviceArr.getEddystones || deviceArr.getReaders
        || deviceArr.getBluetoothHubs || deviceArr.getGateways || deviceArr.getSensors
        || deviceArr.getNFCTags || deviceArr.getLightings)
    })
    .map((deviceArr) => {
      return (deviceArr && deviceArr.length > 0) ? [deviceArr[0]] : deviceArr
    });

    console.log('duplicated', duplicated);

    duplicated = duplicated.reduce((a,b) => [...a,...b], []);

    yield put(validateDevicesSuccess(duplicated));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateShadowCall({payload}) {

  try {
    const updatedShadow = yield call(updateShadowRequest, payload);
    yield put(updateShadowSuccess(updatedShadow));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* otaUpdateCall({payload}) {

  try {
    const otaUpdated = yield call(otaUpdateRequest, payload);
    yield put(otaUpdateSuccess(otaUpdated));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* fetchDeviceLogsCall({payload}) {
  const {deviceId} = payload;

  try {
    const fetchDeviceLogs = yield call(fetchDeviceLogsRequest, deviceId);
    yield put(fetchDeviceLogsSuccess(deviceId, fetchDeviceLogs));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createMeshElementCall({payload}) {

  try {
    const createdMeshElement = yield call(createMeshElementRequest, payload);
    yield put(createMeshElementSuccess(createdMeshElement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateMeshElementCall({payload}) {
  try {
    const updatedMeshElement = yield call(updateMeshElementRequest, payload);
    yield put(updateMeshElementSuccess(updatedMeshElement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteMeshElementCall({payload}) {

  try {
    const deletedMeshElement = yield call(deleteMeshElementRequest, payload);
    yield put(deleteMeshElementSuccess(deletedMeshElement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* fetchWifiTestsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchWifiTests = yield call(fetchWifiTestsRequest, applicationId);
    yield put(fetchWifiTestsSuccess(applicationId, fetchWifiTests));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* openBuzzVoxLockCall({payload}) {
  try {
    const response = yield call(openBuzzVoxLockRequest, payload);
    yield put(openBuzzVoxLockSuccess(response));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchSensors() {
  yield takeEvery(FETCHSENSORS, fetchSensorsCall);
}

export function* fetchNFCTags() {
  yield takeEvery(FETCHNFCTAGS, fetchNFCTagsCall);
}

export function* fetchNFCTagsConnection() {
  yield takeEvery(FETCHNFCTAGSCONNECTION, fetchNFCTagsConnectionCall);
}

export function* countNFCTagsByLatLng() {
  yield takeEvery(COUNTNFCTAGSLATLNG, countNFCTagsByLatLngCall);
}

export function* countSerialRange() {
  yield takeEvery(COUNTSERIALRANGE, countSerialRangeCall);
}

export function* getSerialRange() {
  yield takeEvery(GETSERIALRANGE, getSerialRangeCall);
}

export function* fetchLightings() {
  yield takeEvery(FETCHLIGHTINGS, fetchLightingsCall);
}

export function* fetchIBeacons() {
  yield takeEvery(FETCHIBEACONS, fetchIBeaconsCall);
}

export function* fetchEddystones() {
  yield takeEvery(FETCHEDDYSTONES, fetchEddystonesCall);
}

export function* fetchReaders() {
  yield takeEvery(FETCHREADERS, fetchReadersCall);
}

export function* fetchHubs() {
  console.log('fetchHubs');
  yield takeEvery(FETCHHUBS, fetchHubsCall);
}

export function* fetchGateways() {
  yield takeEvery(FETCHGATEWAYS, fetchGatewaysCall);
}


export function* fetchIBeacon() {
  yield takeEvery(FETCHIBEACON, fetchIBeaconCall);
}

export function* fetchEddystone() {
  yield takeEvery(FETCHEDDYSTONE, fetchEddystoneCall);
}

export function* fetchReader() {
  yield takeEvery(FETCHREADER, fetchReaderCall);
}

export function* fetchHub() {
  yield takeEvery(FETCHHUB, fetchHubCall);
}

export function* fetchGateway() {
  yield takeEvery(FETCHGATEWAY, fetchGatewayCall);
}

export function* fetchModels() {
  yield takeEvery(FETCHMODELS, fetchModelsCall);
}

export function* createDevice() {
  yield takeEvery(CREATEDEVICE, createDeviceCall);
}

export function* updateDevice() {
  yield takeEvery(UPDATEDEVICE, updateDeviceCall);
}

export function* deleteDevice() {
  yield takeEvery(DELETEDEVICE, deleteDeviceCall);
}

export function* createIBeacon() {
  yield takeEvery(CREATEIBEACON, createIBeaconCall);
}

export function* updateIBeacon() {
  yield takeEvery(UPDATEIBEACON, updateIBeaconCall);
}

export function* deleteIBeacon() {
  yield takeEvery(DELETEIBEACON, deleteIBeaconCall);
}

export function* createEddystone() {
  yield takeEvery(CREATEEDDYSTONE, createEddystoneCall);
}

export function* updateEddystone() {
  yield takeEvery(UPDATEEDDYSTONE, updateEddystoneCall);
}

export function* deleteEddystone() {
  yield takeEvery(DELETEEDDYSTONE, deleteEddystoneCall);
}

export function* createReader() {
  yield takeEvery(CREATEREADER, createReaderCall);
}

export function* updateReader() {
  yield takeEvery(UPDATEREADER, updateReaderCall);
}

export function* deleteReader() {
  yield takeEvery(DELETEREADER, deleteReaderCall);
}


export function* createBluetoothHub() {
  yield takeEvery(CREATEHUB, createBluetoothHubCall);
}

export function* updateBluetoothHub() {
  yield takeEvery(UPDATEHUB, updateBluetoothHubCall);
}

export function* deleteBluetoothHub() {
  yield takeEvery(DELETEHUB, deleteBluetoothHubCall);
}

export function* createGateway() {
  yield takeEvery(CREATEGATEWAY, createGatewayCall);
}

export function* updateGateway() {
  yield takeEvery(UPDATEGATEWAY, updateGatewayCall);
}

export function* deleteGateway() {
  yield takeEvery(DELETEGATEWAY, deleteGatewayCall);
}

export function* createDevices() {
  yield takeEvery(CREATEDEVICES, createDevicesCall);
}

export function* createDevicesParallel() {
  yield takeEvery(CREATEDEVICESPARALLEL, createDevicesParallelCall);
}

export function* deleteDevices() {
  yield takeEvery(DELETEDEVICES, deleteDevicesCall);
}

export function* validateDevices() {
  yield takeEvery(VALIDATEDEVICES, validateDevicesCall);
}

export function* updateShadow() {
  yield takeEvery(UPDATESHADOW, updateShadowCall);
}

export function* otaUpdate() {
  yield takeEvery(OTAUPDATE, otaUpdateCall);
}

export function* fetchDeviceLogs() {
  yield takeEvery(FETCHDEVICELOGS, fetchDeviceLogsCall);
}

export function* createMeshElement() {
  yield takeEvery(CREATEMESHELEMENT, createMeshElementCall);
}

export function* updateMeshElement() {
  yield takeEvery(UPDATEMESHELEMENT, updateMeshElementCall);
}

export function* deleteMeshElement() {
  yield takeEvery(DELETEMESHELEMENT, deleteMeshElementCall);
}

export function* fetchWifiTests() {
  yield takeEvery(FETCHWIFITESTS, fetchWifiTestsCall);
}

export function* openBuzzVoxLock() {
  yield takeEvery(OPENBUZZVOXLOCK, openBuzzVoxLockCall);
}

export default function* rootSaga() {
  yield all([
    fork(fetchSensors),
    fork(fetchNFCTags),
    fork(fetchNFCTagsConnection),
    fork(fetchLightings),
    fork(fetchIBeacons),
    fork(fetchEddystones),
    fork(fetchReaders),
    fork(fetchHubs),
    fork(fetchGateways),
    fork(fetchIBeacon),
    fork(fetchEddystone),
    fork(fetchReader),
    fork(fetchHub),
    fork(fetchGateway),
    fork(fetchModels),
    fork(createDevice),
    fork(updateDevice),
    fork(deleteDevice),
    fork(createIBeacon),
    fork(updateIBeacon),
    fork(deleteIBeacon),
    fork(createEddystone),
    fork(updateEddystone),
    fork(deleteEddystone),
    fork(createReader),
    fork(updateReader),
    fork(deleteReader),
    fork(createBluetoothHub),
    fork(updateBluetoothHub),
    fork(deleteBluetoothHub),
    fork(createGateway),
    fork(updateGateway),
    fork(deleteGateway),
    fork(createDevices),
    fork(createDevicesParallel),
    fork(deleteDevices),
    fork(validateDevices),
    fork(updateShadow),
    fork(otaUpdate),
    fork(fetchDeviceLogs),
    fork(createMeshElement),
    fork(updateMeshElement),
    fork(deleteMeshElement),
    fork(fetchWifiTests),
    fork(openBuzzVoxLock),
    fork(countNFCTagsByLatLng),
    fork(getSerialRange),
    fork(countSerialRange)
    ]);
}
